import * as Types from '../../common/types/graphql-types';

import { gql } from '@apollo/client';
export type BaseProductFragment = { __typename?: 'Product', id: string, name: string, type: Types.ProductType, features: Array<string>, calloutText?: string | null | undefined, prices: Array<{ __typename?: 'Price', id: string, amount: number, interval?: Types.PriceInterval | null | undefined }> };

export const BaseProductFragmentDoc = gql`
    fragment BaseProduct on Product {
  id
  name
  type
  features
  calloutText
  prices {
    id
    amount
    interval
  }
}
    `;